import {
  ArticleFormat,
  GetAuthorsQuery,
  GetCategoryQuery_query,
} from '../../../__generated__/queries-web';
import {
  NotificationTypeEnum,
  useNotification,
} from '@prismamedia/one-components';
import { useQuery } from '@apollo/client';
import { GET_BOARD_CARD } from '../../../apollo/queries/cards.board.graphql';
import { emptyConfig } from '../utils/emptyTypes';
import uuidv4 from 'uuid/v4';
import { CircularProgress } from '@mui/material';
import { ArticleEdit } from '../ArticleEdit';
import { RouteComponentProps } from 'react-router-dom';
import { GetBoardCardQuery_query } from '../../../__generated__/queries-board';
import { GET_CATEGORY } from '../../../apollo/sharedQueries/categories.query.web.graphql';
import { GET_AUTHORS } from '../../../apollo/queries/authors.web.graphql';

interface EditBoardCardParams {
  brandKey: string;
  articleType: string;
  cardId: string;
}

export const EditBoardCard = ({
  match,
}: RouteComponentProps<EditBoardCardParams>) => {
  const { articleType, cardId, brandKey } = match.params;
  const { pushNotification } = useNotification();

  const { data: card, loading: cardLoading, error } = useQuery<
    GetBoardCardQuery_query
  >(GET_BOARD_CARD, {
    variables: {
      where: {
        id: cardId,
      },
    },
    onError: () => {
      pushNotification({
        message: "Erreur lors de la récupération de l'article",
        type: NotificationTypeEnum.error,
      });
    },
  });
  const { data: category } = useQuery<GetCategoryQuery_query>(GET_CATEGORY, {
    variables: {
      where: {
        id: card?.card?.category,
      },
    },
    skip: !card?.card?.category,
  });
  const { data: authors } = useQuery<GetAuthorsQuery>(GET_AUTHORS, {
    variables: {
      where: {
        brandKey,
        id_in: card?.card?.authors.map((author) => author.author?.id),
      },
      first: 10,
    },
    skip: !card?.card?.authors.length,
  });

  const webArticle = {
    ...emptyConfig,
    id: uuidv4(),
    title: card?.card?.title || '',
    format:
      articleType === 'article' ? ArticleFormat.Rich : ArticleFormat.Video,
    brandKey,
    categories: category ? [category] : [],
    authors:
      authors && authors.authors.length
        ? authors.authors.map((author) => ({
            author: {
              name: author.name,
              id: author.id,
              avatarUrl: author.avatarUrl,
            },
          }))
        : [],
    publishedAt: card?.card?.publicationDate
      ? new Date(card?.card?.publicationDate)
      : null,
  };

  if (error) {
    return (
      <>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
          }}
        >
          <p style={{ marginTop: '1rem', fontSize: '1.5rem' }}>
            Erreur lors de la récupération de l'article
          </p>
        </div>
      </>
    );
  }
  return cardLoading ? (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress size={80} />
        <p style={{ marginTop: '1rem', fontSize: '1.5rem' }}>
          Chargement des données article en cours...
        </p>
      </div>
    </>
  ) : (
    <ArticleEdit data={webArticle} disableConcurrentialAccess={true} />
  );
};
